export const RISK_LEVEL_OF_CONTROLS = [
  'Eliminate the hazard',
  'Substitute the hazard',
  'Isolate the hazard',
  'Use engineering controls',
  'Use administrative controls',
  'Use personal protective equipment (PPE)',
  'Minimise the Hazard'
];
